import {
  extractLastNameComponent,
  pathToModuleStyle,
} from '@spotify/confidence-core-react';

import { getArtifactDisplayName } from '../artifactUtils';
import {
  type ArtifactPreviewTarget,
  DEFAULT_ARTIFACT_ICON,
  resolveArtifactIcon,
  useArtifactExtensions,
} from '../extensions/artifact-extension';

export const useArtifactDisplay = (
  target: ArtifactPreviewTarget,
  resolvedDisplayName?: string,
) => {
  const extensions = useArtifactExtensions();
  const { attachment, uri } = target;
  const previewExtension = extensions.find(e => e.preview?.predicate(target));
  const preview = previewExtension?.preview;
  const ext = attachment
    ? extensions.find(e => e.predicate(attachment))
    : undefined;
  const { Icon } =
    preview?.icon?.(target) ??
    (attachment ? resolveArtifactIcon(ext, attachment) : DEFAULT_ARTIFACT_ICON);
  const typeLabel =
    pathToModuleStyle(uri)?.label ??
    previewExtension?.label ??
    ext?.label ??
    'Link';
  const fallbackName =
    resolvedDisplayName || extractLastNameComponent(uri) || '';
  const displayName = attachment
    ? getArtifactDisplayName(attachment, fallbackName)
    : fallbackName;

  return { Icon, typeLabel, displayName, ext, preview };
};
